import React, { Component } from 'react';
import {
  shape, number, string, func,
} from 'prop-types';
import {
  Card,
  Heading,
  Small,
  HtmlParser,
} from 'components/common';
import './RewardSlickPane.scss';

class RewardSlickPane extends Component {
  componentDidMount() {
    const { cardRef, index } = this.props;
    cardRef(this.cardElmnt, index);
  }

  render() {
    const {
      index,
      title,
      tandc,
      labelOption,
      height,
    } = this.props;

    const updateHeight = height !== 0 ? height : 'null';
    return (
      <div className="reward-slick-pane">
        <Card preserveShapeOnMobile>
          <Card.Content>
            <div className="reward-slick-pane-content" style={{ height: updateHeight }} ref={(elements) => { this.cardElmnt = elements; }}>
              <div>
                <Small primary>
                  {/* TODO(victor): i18n */}
                  <strong>{`${labelOption} ${index}`}</strong>
                </Small>
              </div>
              <div className="reward-slick-pane-title-wrapper">
                {title && (
                  <div className="reward-slick-pane-title">
                    <Heading as="h3">
                      <div className="reward-slick-pane-title-inner">
                        {title}
                      </div>
                    </Heading>
                  </div>
                )}
              </div>
              {tandc && (
                <div className="reward-slick-pane-conditions">
                  <HtmlParser htmlString={tandc.longDescrition} />
                </div>
              )}
            </div>
          </Card.Content>
        </Card>
      </div>

    );
  }
}

RewardSlickPane.defaultProps = {
  title: null,
  tandc: null,
  index: 1,
  labelOption: null,
  height: 100,
  cardRef: null,
};

RewardSlickPane.propTypes = {
  title: string,
  tandc: shape({}),
  index: number,
  labelOption: string,
  height: number,
  cardRef: func,
};

export default RewardSlickPane;
